import { render, staticRenderFns } from "./CreateTopicList.vue?vue&type=template&id=72d2c5c2"
import script from "./CreateTopicList.vue?vue&type=script&lang=js"
export * from "./CreateTopicList.vue?vue&type=script&lang=js"
import style0 from "./CreateTopicList.vue?vue&type=style&index=0&id=72d2c5c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports